import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import memberContext from "../../store/Member";
import "./Header.scss";
import UserTab from "./UserTab";
import UnEventContext from "../../store/UnEvent";
import WithPreventScroll from "../../HOC/WithPreventScroll";
import CommonContext from "../../store/Common";
import MobilePopupContext from "../../store/MobilePopup";
import CommonAPI from "../../API/common";
import UnEventAPI from "../../API/unevent";


function Header({ history }) {
  const location = useLocation();
  const unEvent = useContext(UnEventContext);
  const memberInfo = useContext(memberContext);
  const common = useContext(CommonContext);
  const { isMobile } = common;
  const showBoard =
    String(
      common.board_service != null
        ? common.board_service
        : sessionStorage.getItem("board_service")
    ) === "true";
  const { mobilePopup, setMobilePopup } = useContext(MobilePopupContext);
  const auth = memberInfo.auth;
  const isLogin = auth != null && auth != undefined;
  const isCompany = window.$Global.checkAuth("특허회사", memberInfo.auth);
  const isInvestor = window.$Global.checkAuth("투자자", memberInfo.auth);
  const isInventor = window.$Global.checkAuth(
    "특허회사_발명자만",
    memberInfo.auth
  );
  const [moMenuShow, setMoMenuShow] = useState(false);
  const qs = new URLSearchParams(location.search);
  const pageType = qs.get("pageType");
  const code = qs.get("code");
  const [companyLogo, setCompanyLogo] = useState(null);

  const isCalcPath = window.location.pathname === "/calc";

  const redirect = () => {
    isInventor
      ? (window.location.href = "/invention/list")
      : window.$Global.redirectHome(auth);
  };

  const ipnowLogo = (
    <img
      src={
        companyLogo
          ? window.$Global.getCDN(companyLogo.image_key)
          : require("../../assets/images/common/logo_ipnow.svg").default
      }
      style={{ position: "relative", width: 84 }}
      onClick={redirect}
      alt="이미지"
    />
  );

  useEffect(() => {
    if (code && isLogin) {
      CommonAPI.getCompanyCode(code).then((res) => {
        setCompanyLogo(res.data);
      });
    }
  }, [code]);

  useEffect(() => {
    CommonAPI.log().then(() => console.info("logging success")); // 로깅
  }, [location]);

  useEffect(() => {
    const unlisten = history.listen(() => {
      setMoMenuShow(false);
    });
    return () => {
      unlisten();
    };
  }, []);

  const onClickLogout = () => window.$Global.logout();

  const onClickChangeView = () => {
    window.$Global.toggleViewType();
  };

  const onClickClosePopup = () => {
    setMobilePopup({
      ...mobilePopup,
      mobileShow: false,
      mobileHeaderTitle: mobilePopup.historyMobileHeaderTitle,
    });
  };

  const SettingByHOC = () => {
    return (
      <div
        className={`dimmed ${moMenuShow ? "show" : "hide"}`}
        onClick={() => setMoMenuShow(false)}
      />
    );
  };

  const ComponentWithDimmed = WithPreventScroll(SettingByHOC, moMenuShow);

  let exceptCondition;

  if (isMobile) {
    exceptCondition = !isMobile || isCalcPath;
  } else {
    exceptCondition = (!isLogin && !isMobile) || isCalcPath;
  }

  if (exceptCondition) return null;

  const RenewalHeader = () => {
    return (
      <div className="wrap_header pc">
        <div className="header_left">
          <div onClick={redirect} style={header_h1}>
            {ipnowLogo}
          </div>
          <div className="homeBtn">
            <div className="oval" />
          </div>
          <div className="groupwareBtn">
            <div className="oval" />
            <p>그룹웨어</p>
          </div>
        </div>
        <div className="wrap_header_utill">
          {isLogin ? (
            <UserTab
              member={memberInfo}
              onClickLogout={onClickLogout}
              unEvent={unEvent}
            />
          ) : (
            <div className="user_tab">
              <ul className="header_user_tab_ul">
                <li style={header_user_tab_li}>
                  <Link to="/signup/type" style={{ ...link }}>
                    회원가입
                  </Link>
                </li>
                <li style={header_user_tab_li}>
                  <Link to="/login" style={{ ...link }}>
                    로그인
                  </Link>
                </li>
              </ul>
            </div>
          )}
          <ul className="toolbar-wrap">
            <li className="toolbar">
              <button
                type="button"
                className="toolbar_btn"
                onClick={onClickChangeView}
              >
                <span style={{ color: "#4593f5" }}>
                  BIZNAVI 바로가기 &nbsp; &gt;
                </span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    );
  };
  return (
    <div id="Header">
      {location.pathname.includes("renewal") === true ? (
        <RenewalHeader />
      ) : (
        <div className="wrap_header pc">
          <div onClick={redirect} style={header_h1}>
            {ipnowLogo}
          </div>
          <div className="wrap_header_utill">
            {isLogin ? (
              <UserTab
                member={memberInfo}
                onClickLogout={onClickLogout}
                unEvent={unEvent}
              />
            ) : (
              <div className="user_tab">
                <ul className="header_user_tab_ul">
                  <li style={header_user_tab_li}>
                    <Link to="/signup/type" style={{ ...link }}>
                      회원가입
                    </Link>
                  </li>
                  <li style={header_user_tab_li}>
                    <Link to="/login" style={{ ...link }}>
                      로그인
                    </Link>
                  </li>
                </ul>
              </div>
            )}
            <ul className="toolbar-wrap">
              <li className="toolbar">
                <button
                  type="button"
                  className="toolbar_btn"
                  onClick={onClickChangeView}
                >
                  <span style={{ color: "#4593f5" }}>
                    BIZNAVI 바로가기 &nbsp; &gt;
                  </span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
      <div className="wrap mo">
        <div className="menu_top">
          {mobilePopup.mobileShow || mobilePopup.historyMobileHeaderTitle ? (
            <>
              {/* X 버튼 및 타이틀 */}
              <button
                type="button"
                className="btnDel"
                onClick={onClickClosePopup}
              >
                창 닫기
              </button>
              <div className="menu_top_title">
                {mobilePopup.mobileHeaderTitle}
              </div>

              {/* < 버튼 및 타이틀 */}
              {/* <button type="button" className="prevDel">이전 페이지로</button>
                                    <div className="menu_top_title">제안서 샘플 마켓</div>
                                    <div className="btns"></div> */}
            </>
          ) : (
            <>
              <button className="m_logo1" onClick={redirect}>
                홈으로
              </button>
              <div className="btns">
                <button
                  className="btn_change btn_findbiz"
                  onClick={onClickChangeView}
                >
                  BizNavi 전환
                </button>
                {isLogin ? (
                  !isInvestor && (
                    <Link
                      to="/alarm"
                      className={`icon_m_bell${
                        unEvent.unConfirmEventCnt > 0 ? "_on" : ""
                      }`}
                    />
                  )
                ) : (
                  <Link to="/login" className="icon_m_login">
                    로그인
                  </Link>
                )}
                {moMenuShow ? (
                  <button
                    className="icon_exit"
                    onClick={() => setMoMenuShow(false)}
                  />
                ) : (
                  <button
                    className="icon_m_menu"
                    onClick={() => setMoMenuShow(true)}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="mo">
        <div className="more_menu">
          <ComponentWithDimmed />
          <div className={`menus ${moMenuShow ? "menu_animation" : ""}`}>
            {isLogin && !isInvestor && (
              <>
                <div className="myinfo">
                  <div className="access_account">
                    <h2>{memberInfo.name}님</h2>
                    {memberInfo.company != "null" && (
                      <p>{memberInfo.company}</p>
                    )}
                  </div>
                  <div className="btns">
                    {showBoard && (
                      <Link to="/board/list" className="btn_mypage">
                        게시판
                        <i className="icon_arrow_right_orange" />
                      </Link>
                    )}
                    <Link to="/mypage/mobile" className="btn_mypage">
                      마이페이지
                      <i className="icon_arrow_right_orange" />
                    </Link>
                    {!isInvestor && (
                      <Link to="/manage/mobile" className="btn_auth">
                        관리
                        <i className="icon_more_arrow_right_white" />
                      </Link>
                    )}
                  </div>
                </div>
                {isCompany && (
                  <>
                    <div className="m_item">
                      <p>
                        IP 관리
                        <i className="icon_more_arrow_down" />
                      </p>
                      <ul>
                        <li>
                          <Link to="/patent/mlist">특허 관리</Link>
                        </li>
                        <li>
                          <Link to="/tradeMark/mlist">상표 관리</Link>
                        </li>
                        <li>
                          <Link to="/design/mlist">디자인권 관리</Link>
                        </li>
                      </ul>
                    </div>
                  </>
                )}
              </>
            )}
            {!isInvestor && (
              <div className="m_item">
                <p>
                  기업 정보
                  <i className="icon_more_arrow_down" />
                </p>
                {/*<ul>*/}
                {/*  <li>*/}
                {/*    <Link to="/people">구성원 소개</Link>*/}
                {/*  </li>*/}
                {/*</ul>*/}
              </div>
            )}
            {!isLogin && (
              <>
                {/*<div className="m_item">*/}
                {/*  <Link to="/intro/price">*/}
                {/*    이용가격*/}
                {/*    <i className="icon_more_arrow_right" />*/}
                {/*  </Link>*/}
                {/*</div>*/}
                <div className="m_item">
                  <Link to="/intro/service">
                    고객지원
                    <i className="icon_more_arrow_right" />
                  </Link>
                </div>
              </>
            )}
            {isLogin && (
              <div className="m_item">
                <p onClick={onClickLogout}>
                  로그아웃
                  <i className="icon_more_arrow_right" />
                </p>
              </div>
            )}
            <div className="wrap_agree">
              <Link to="/terms/use">서비스 이용약관</Link>
              <Link to="/terms/private">개인정보 개인정보</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const header_h1 = {
  lineHeight: "40px",
  fontSize: "20px",
  color: "#ffffff",
  textAlign: "right",
  cursor: "pointer",
  display: "flex",
};

const link = {
  display: "block",
  width: "80px",
  textAlign: "center",
};

const margin_left = {
  marginLeft: "18px",
};

const font_size_11 = {
  fontSize: "11px",
};

const pointer = {
  cursor: "pointer",
};

const header_user_tab_li = {
  display: "flex",
  alignItems: "center",
  ...margin_left,
  ...font_size_11,
  ...pointer,
};

export default Header;
